import { FC } from 'react';
import { NudosButton, NudosGenericModal } from '../NudosComponents';
import BordOneToneIcon from '../NudosComponents/BordOneToneIcon/BordOneToneIcon';

import './ModalMoveWithPendingConfiguration.scss';

interface IModalMoveWithPendingConfigurationProps {
  showPendingConfigurationModal: boolean;
  setShowPendingConfigurationModal: React.Dispatch<React.SetStateAction<boolean>>;
  setShowProcessModal: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
}
const ModalMoveWithPendingConfiguration: FC<IModalMoveWithPendingConfigurationProps> = ({
  showPendingConfigurationModal,
  setShowPendingConfigurationModal,
  setShowProcessModal,
  message
}: IModalMoveWithPendingConfigurationProps) => {
  const closeModal = () => {
    setShowPendingConfigurationModal(false);
  };

  const closeModalAndOpenProcessModal = () => {
    setShowPendingConfigurationModal(false);
    setShowProcessModal(true);
  };

  if (!showPendingConfigurationModal) return null;

  return (
    <NudosGenericModal
      modalContent={
        <div className="modalMoveWithPendingConfiguration">
          <div className="alertIconContainer">
            <div className="alertIconYellow">
              <BordOneToneIcon variant="alertTriangleWarning" standardSize={20} stroke="#FFBB00" />
            </div>
          </div>
          <div className="titleModalContainer" dangerouslySetInnerHTML={{ __html: message }} />
          <div className="buttonsModalContainer">
            <NudosButton
              colorPalette="secondary"
              buttonText="No, cancelar"
              componentSize="small"
              handleClick={closeModal}
            />
            <NudosButton
              colorPalette="primary"
              buttonText="Sí, pasar a Proceso de entrega"
              componentSize="small"
              handleClick={closeModalAndOpenProcessModal}
            />
          </div>
        </div>
      }
    />
  );
};

export default ModalMoveWithPendingConfiguration;
